import sidebar from "./sidebar/sidebar";

export default { ...sidebar };
